module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 preloader"
  }, [_c('div', {
    staticClass: "preloader__status"
  }, [_c('div', {
    staticClass: "preloader__status-text",
    attrs: {
      "status": ""
    }
  }, [_vm._v("Загружено на " + _vm._s(_vm.loaded) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "preloader__status-loader"
  }, [_c('div', {
    staticClass: "preloader__status-bar",
    style: (_vm.loadStyle),
    attrs: {
      "loader": ""
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c49126","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue-source/src/app/components/preload.vue
// module id = 186
// module chunks = 0